"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('dropdown');
const Dropdown = (props) => {
    const { options = [], value, activeColor = '#1890FF', onChange } = props;
    return (React.createElement(one_1.View, { className: prefixCls },
        React.createElement(one_1.View, { className: `${prefixCls}-content` }, options.map(item => (React.createElement(one_1.View, { className: `${prefixCls}-content-option`, key: item.key, onTap: () => onChange === null || onChange === void 0 ? void 0 : onChange(item), style: item.key === value
                ? {
                    color: activeColor,
                    fontWeight: 500,
                }
                : undefined }, item.value))))));
};
exports.default = Dropdown;
